import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "jQuery imageless buttons a la Google take two",
  "description": "",
  "published": "2009-02-19T00:00:00.000Z",
  "redirect_from": ["/blog/jquery-imageless-buttons-a-la-google-take-two/swizec/5"],
  "categories": "creation, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On Monday I released these buttons and as many of you noted I seriously didn't do nearly enough testing and what's worse, I even bragged about the fact. But some of you perhaps noticed my edits to the blogpost where I said I'd make it all better. Well, here's Wednesday and I made it all better while still, as promised, spending much less time than Google probably did. Think I've spent under 20 hours for the whole thing from inception to finish (now). If you're lazy just head over to the `}<a parentName="p" {...{
        "href": "http://swizec.com/code/styledButton"
      }}>{`jQuery imageless buttons a la Google examples/documentation`}</a>{` page.`}</p>
    <p>{`Let's start off with a screenshot of what the buttons look like on modern browsers`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/code/styledButton/normal_example.png",
        "alt": "Imageless buttons on proper browsers",
        "title": "Imageless buttons on proper browsers"
      }}></img></p>
    <p>{`I spent a good deal of last night making sure they also look like this on many older browsers, in fact these are now officially supported:`}<br parentName="p"></br>{`
`}{`Opera 9.6x`}<br parentName="p"></br>{`
`}{`Firefox 3`}<br parentName="p"></br>{`
`}{`Firefox 2`}<br parentName="p"></br>{`
`}{`Safari 3`}<br parentName="p"></br>{`
`}{`Safari 2`}<br parentName="p"></br>{`
`}{`Internet Explorer 8 beta`}<br parentName="p"></br>{`
`}{`Internet Explorer 7`}<br parentName="p"></br>{`
`}{`Internet Explorer 6`}<br parentName="p"></br>{`
`}{`Chrome`}</p>
    <p>{`And I seriously hope that's enough for your needs, if supporting all of those isn't enough for you then I'm not certainit's even possible to satisfy your needs. Personally I must admit I've learned a lot in getting all of these browsers to work. Most of all that Firefox 2 doesn't have an inline-block, but rather a -moz-inline-block for some strange reason. It's also interesting to not that Safari 2 and IE break when you have trailing commas in your lists of properties, which I'm used to so it's easier to add stuff.`}</p>
    <p>{`Anyhow, here's what the buttons look like in Firefox 2`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/code/styledButton/FF2_example.png",
        "alt": "Imageless buttons in Firefox 2",
        "title": "Imageless buttons in Firefox 2"
      }}></img></p>
    <p>{`And what they're like Internet Explorer 6`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/code/styledButton/ie6_example.png",
        "alt": "Imageless buttons in IE6",
        "title": "Imageless buttons in IE6"
      }}></img></p>
    <p>{`I should probably also note that there are two known issues with the buttons. Namely that in Internet Explorer onchange events don't work since it doesn't allow firing them on noninput elements and that in IE the darker border on the right vanishes on activated buttons for some reason, I was simply too tired to hunt this one down and you know what, I can live with a minor glitch such as that.`}</p>
    <p>{`Since you're still reading, please head over to the `}<a parentName="p" {...{
        "href": "http://swizec.com/code/styledButton"
      }}>{`jQuery imageless buttons a la Google`}</a>{` examples now.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      